import { NounNumeralVariants } from './types'

const cardinalDiscriminator = new Intl.PluralRules('ru-RU', { type: 'cardinal' })

/**
 * Создает функцию согласующую число и слово
 *
 * @param {NounNumeralVariants} map соответствие слову {@linkcode PluralRule}
 * @returns {(amount: number) => string} функция, возвращающая правильный вариант слова по количеству
 */
export const connectToCardinalNumeralFactory = (map: NounNumeralVariants) => (amount: number) => {
  const pluralRule = cardinalDiscriminator.select(amount)
  return map[pluralRule]
}
